import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  api,
  type PublicEventPageData,
  type EventPageSettings,
} from '../api/client';

/**
 * Hook to fetch a public event page by slug or ID.
 */
export function usePublicEventPage(slug: string | undefined) {
  return useQuery<PublicEventPageData>({
    queryKey: ['publicEventPage', slug],
    queryFn: () => api.eventPage.getPublic(slug!),
    enabled: !!slug,
  });
}

/**
 * Hook to update event page settings (host-facing).
 */
export function useUpdateEventPageSettings(eventId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation<
    EventPageSettings,
    Error,
    {
      descriptionHtml?: string | null;
      bannerImageUrl?: string | null;
      virtualEventUrl?: string | null;
      virtualEventType?: string | null;
      mapEmbedUrl?: string | null;
      showGuestList?: boolean;
      slug?: string | null;
    }
  >({
    mutationFn: (data) => api.eventPage.updateSettings(eventId!, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['event', eventId] });
      queryClient.invalidateQueries({ queryKey: ['publicEventPage'] });
    },
  });
}
